import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: '',
    userinfo: null,
    userID: '',
    isLogin: false,
    url: 'https://jybks.chuxingshi.top',//图片路径
  },
  mutations: {
    login(state,data) {//登录
      state.isLogin = true
      state.userinfo = data
      state.userID = data.id
      localStorage.setItem('jiaoyu',JSON.stringify(data))
    },
    logout(state) {
      state.isLogin = false
      state.userinfo = null
      state.userID = ''
    },
    getUserStorage(state) { //获取用户登录缓存
      let data = JSON.parse(localStorage.getItem('jiaoyu'))
      state.userinfo = data
    },
  },
  actions: {
  },
  modules: {
  }
})
